let PackagesItem = [
    {
        trackJunior: true,
        trackTitle: "Junior Track",
        trackSubtitle: true,
        trackPrice: "0",
        runningString: true,
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticketfree/1696333272940x857516382954979300',
    },
    {
        trackFull: true,
        trackTitle: "FULL ACCESS 🔥",
        trackSubtitle: "ticket",
        runningString: true,
        trackPrice: "199",
        earlyBird: "early birds price",
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Junior Track',
        trackList2: 'Senior Track - June 25',
        trackLink: 'https://geekle.us/ticket/1696333235238x626393554813190100',
    },
    {
        trackTitle: "YEAR OF ANGULAR ❤️",
        trackSubtitle: "package",
        runningString: true,
        trackPrice: "249",
        earlyBird: "one year access",
        trackDesc: "1",
        trackText: true,
        yearTrackText: true,
        trackText1: "One Year Package",
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticket/1711017223014x690589533268869100',
    },
    {
        newPremium: true,
        trackTitle: "GEEKLE PREMIUM",
        trackSubtitle: "MEMBERSHIP",
        trackPriceApperance: 2,
        trackPrice: "399",
        trackText: true,
        trackText1: "One Year Premium Membership",
        trackDesc: "1",
        trackButton: "BUY",
        trackLink: 'https://geekle.us/ticket/1696847842733x949907249339039700',
        inverseColors: true,
    },
    // {
    //     trackTitle: "TEAM-5",
    //     trackSubtitle: "YEAR GROUP PACKAGE",
    //     trackPriceApperance: 3,
    //     runningString: true,
    //     trackPrice: "999",
    //     trackText: true,
    //     trackText1: "One Year Pass for 5 team members",
    //     trackDesc: "1",
    //     trackButton: "BUY",
    //     trackLink: 'https://geekle.us/ticket/1694109810106x843614570263085000',
    // },
    {
        trackTitle: "UNLIMITED",
        trackSubtitle: "YEAR ENTERPRISE PACKAGE",
        trackPriceApperance: 4,
        runningString: true,
        trackPrice: "Ask Our Manager",
        trackText: true,
        trackText1: "One Year Pass for up to 100 members",
        trackDesc: "1",
        trackButton: "Get Offer",
        trackLink: 'enterprise',
        validDate: '9.06',
    },
];

export default PackagesItem;
